<template>
  <header>
    <div class="layout">
      <div class="logo">
          <img src="@/assets/img/logo-colorido.png" alt="">
      </div>
      <div class="contato">
        <p>Fale com um consultor</p>
        <p><strong>+ 55 27 99700-4778</strong></p>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>
